import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4 p-3 bg-blue-50 border border-blue-200 rounded-md"
}
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "text-blue-700 text-sm font-medium" }
const _hoisted_4 = {
  key: 0,
  class: "mt-3 border-t border-blue-200 pt-3"
}
const _hoisted_5 = { class: "font-medium" }
const _hoisted_6 = { class: "font-medium" }
const _hoisted_7 = { class: "font-medium" }
const _hoisted_8 = { class: "mt-1 text-sm text-gray-600" }
const _hoisted_9 = { class: "mt-1 text-xs text-gray-500" }

import { ref } from "vue";
import { useChallengeConfigurations } from "@/composables/tasks/challenge/useChallengeConfigurations";


export default /*@__PURE__*/_defineComponent({
  __name: 'HistoryList',
  setup(__props) {

const { getChallengeConfigurationsHistory } = useChallengeConfigurations();

const showHistory = ref(false);
// Toggle history display
const toggleHistory = () => {
    showHistory.value = !showHistory.value;
};

// Format history item display value
const getValueDisplay = (value: any): string => {
    if (!value) return 'None';
    return value.label || value.name || JSON.stringify(value);
};


return (_ctx: any,_cache: any) => {
  return (_unref(getChallengeConfigurationsHistory)().length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getChallengeConfigurationsHistory)().length) + " change(s) recorded", 1)
          ]),
          _createElementVNode("button", {
            onClick: toggleHistory,
            class: "text-blue-600 text-sm underline"
          }, _toDisplayString(showHistory.value ? 'Hide History' : 'View History'), 1)
        ]),
        (showHistory.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getChallengeConfigurationsHistory)(), (change) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: change.id,
                  class: "mb-3 pb-3 border-b border-blue-100 last:border-b-0"
                }, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(change.fieldName), 1),
                  _createElementVNode("div", null, [
                    _cache[0] || (_cache[0] = _createTextVNode(" Changed from ")),
                    _createElementVNode("span", _hoisted_6, _toDisplayString(getValueDisplay(change.oldValue)), 1),
                    _cache[1] || (_cache[1] = _createTextVNode(" to ")),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(getValueDisplay(change.newValue)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-gray-700 font-medium" }, "Justification:", -1)),
                    _createTextVNode(" " + _toDisplayString(change.justification), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(new Date(change.timestamp).toLocaleString()) + " by " + _toDisplayString(change.userName), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})